import { Modals } from 'src/app/types'
import * as allModals from '../components/modal/modals'

// this hook is used to select a modal component when given a type
export const useGetModalContent = (type: Modals | null) => {
  let SelectedModal
  switch (type) {
    case 'sessionCreate':
      SelectedModal = allModals.SessionCreateModal
      break
    case 'sessionDelete':
      SelectedModal = allModals.SessionDeleteModal
      break
    case 'sessionRename':
      SelectedModal = allModals.SessionRenameModal
      break
    case 'sessionEndActive':
      SelectedModal = allModals.SessionEndModal
      break
    case 'groupCreate':
      SelectedModal = allModals.GroupCreateModal
      break
    case 'groupRename':
      SelectedModal = allModals.GroupRenameModal
      break
    case 'groupDelete':
      SelectedModal = allModals.GroupDeleteModal
      break
    default:
      SelectedModal = null
  }
  return SelectedModal
}
